const initInlineVideos = (elements) => {
    elements.forEach(el => {
        const videoEl = el.querySelector('video');

        
        const toggleVideo = () => {
            el.classList.toggle('is-active');
            if(videoEl.paused) {
                videoEl.play();
            } else {
                videoEl.pause();
                videoEl.currentTime = 0;
            }
        }

        el.addEventListener('click', () => {
            toggleVideo();
        });
    })
}

export default initInlineVideos;